import { DEFAULT_API } from './environment';

export const API_URLS = {
  user: {
    login: DEFAULT_API + '/authentication/versions/1/tickets',
    resetPass: '/s/androgogic/login/forgot-password',
    updatePass: '/s/androgogic/login/reset-password',
    getemailusername: '/s/syn/people',
    whoAmI: DEFAULT_API + '/alfresco/versions/1/people/-me-',
    getMyGroups: DEFAULT_API + '/alfresco/versions/1/people/-me-/groups',
    getAll: DEFAULT_API + '/alfresco/versions/1/people',
    logout: '/s/api/login/ticket/:ticket',
    tokenValidation: `${DEFAULT_API}/authentication/versions/1/tickets/-me-`
  },
  sites: {
    sites: DEFAULT_API + '/alfresco/versions/1/people/-me-/sites',
    create: DEFAULT_API + '/alfresco/versions/1/sites',
    getOne: DEFAULT_API + '/alfresco/versions/1/sites/:siteId',
    getMembersAndGroups: '/s/api/sites/:siteId/memberships',
    delete: '/s/api/sites/:siteId/memberships/:elementId',
    deleteSite: '/s/api/sites/:shortName',
    invitationMembers: '/s/api/sites/:siteId/invitations',
    changeUserPermissions: DEFAULT_API + '/alfresco/versions/1/sites/:siteId/members/:memberId',
    extractPdf: '/s/synapture/extarct-pdf',
    createFolder: '/s/api/type/cm%3Afolder/formprocessor',
    findall: '/api/-default-/public/alfresco/versions/1/sites',
    leave: '/api/-default-/public/alfresco/versions/1/people/-me-/sites/:siteId',
    request: '/s/api/sites/:siteId/invitations',
    getMyRequest: '/api/-default-/public/alfresco/versions/1/people/-me-/site-membership-requests',
    cancelRequest: '/s/api/sites/:siteId/invitations/:id',
    getinvitation: '/s/api/sites/:siteId/invitations',
    publicRequest: '/s/api/sites/:siteId/memberships',
    query: DEFAULT_API + '/alfresco/versions/1/queries/sites',
    export: '/s/synapture/internal/downloads',


  },
  nodes: {
    nodes: DEFAULT_API + '/alfresco/versions/1/nodes/:nodeId',
    content: DEFAULT_API + '/alfresco/versions/1/nodes/:nodeId/content',
    versionContent: DEFAULT_API + '/alfresco/versions/1/nodes/:nodeId/content',
    children: DEFAULT_API + '/alfresco/versions/1/nodes/:nodeId/children',
    uploadfile: '/api/upload',
    parents: DEFAULT_API + '/alfresco/versions/1/nodes/:nodeId/parents',
    move: DEFAULT_API + '/alfresco/versions/1/nodes/:elementId/move',
    copy: DEFAULT_API + '/alfresco/versions/1/nodes/:elementId/copy',
    downloads: DEFAULT_API + '/alfresco/versions/1/downloads',
    downloadsState: DEFAULT_API + '/alfresco/versions/1/downloads/:id',
    downloadsContent: DEFAULT_API + '/alfresco/versions/1/nodes/:id/content',
    downloadContentZip: '/s/api/node/content/workspace/SpacesStore/:id',
    getIcon: '/s/api/node/workspace/SpacesStore/:nodeId/content/thumbnails/doclib',
    upload: '/s/api/upload',
    downloadZip: '/s/api/internal/downloads',
    deletezip: '/s/api/internal/downloads/workspace/SpacesStore/:id',
    convert: '/s/api/node/workspace/SpacesStore/:nodeId/content/thumbnails/pdf',
    changeOrder: '/s/syn/changeOrder',
    notify: '/s/synapture/notifyMail',
    updateSite: '/s/api/sites/:siteId',
    fusion: '/s/synapture/merge-pdf',
    generateExcel:'/s/synapture/export/excel'
  },
  docs: {
    convertToPdf: DEFAULT_API + '/alfresco/versions/1/nodes/:nodeId/renditions/pdf/content',
    convertDocxToPdf: '/s/api/node/workspace/SpacesStore/:nodeId/content/thumbnails/pdf?c=force&noCache=1575044119681'
  },
  rooms: {
    create: '/s/resa/salle',
    delete: '/s/resa/salle/:salleid',
    edit: '/s/resa/salle/:salleid',
    get: '/s/resa/salle/:salleid',
    getAll: '/s/resa/salles',
    getParentNodeId: '/s/resa/salles/images/parentId',
    getTodayEvents: '/s/salle/:salleId/up-resas'
  },
  events: {
    create: '/s/salle/reservation',
    edit: '/s/salle/reservation/:eventName',
    getOne: '/s/salle/reservation/:eventName',
    delete: '/s/salle/reservation/:eventName',
    getAll: '/s/salle/resas'
  },
  people: {
    getAll: DEFAULT_API + '/alfresco/versions/1/people',
    get: '/s/api/people/:userId',
    delete: '/s/api/people/:username',
    create: '/s/api/people',
    edit: '/s/api/people/:username',
    updatePassword: '/s/api/person/changepassword/:username',
    query:DEFAULT_API + '/alfresco/versions/1/queries/people'
  },
  groups: {
    getAll: DEFAULT_API + '/alfresco/versions/1/groups',
    getOne: DEFAULT_API + '/alfresco/versions/1/groups/:groupId',
    delete: DEFAULT_API + '/alfresco/versions/1/groups/:groupId',
    getForUser: DEFAULT_API + '/alfresco/versions/1/people/:userId/groups',
    add: DEFAULT_API + '/alfresco/versions/1/groups',
    edit: DEFAULT_API + '/alfresco/versions/1/groups/:groupId',
    getMembers: '/s/api/groups/:groupId/children',
    addMembers: '/s/api/groups/:groupId/children/:memberId',
    deleteMember: '/api/groups/:groupId/children/:memberId'
  },
  search: {
    search: '/api/-default-/public/search/versions/1/search',
    liveSearchDoc: '/s/slingshot/live-search-docs',
    liveSearchSites: '/s/slingshot/live-search-sites',
    liveSearchPeople: 'live-search-people'
  },
  sharedLink: {
    link: '/api/-default-/public/alfresco/versions/1/shared-links',
    getLink: '/api/-default-/public/alfresco/versions/1/shared-links/:sharedId',
    content: '/api/-default-/public/alfresco/versions/1/shared-links/:sharedId/content',
    convertToPdf: '/api/-default-/public/alfresco/versions/1/shared-links/:sharedId/renditions/pdf/content',
    convertDocxToPdf: '/s/api/node/workspace/SpacesStore/:nodeId/content/thumbnails/pdf?c=force&noCache=1575044119681',
    downloads: '/api/-default-/public/alfresco/versions/1/shared-links/downloads',
    downloadsContent: '/api/-default-/public/alfresco/versions/1/shared-links/:sharedId/content',

  },
  comment: {
    create: '/s/api/node/workspace/SpacesStore/:nodeId/comments',
    getAll: '/s/api/node/workspace/SpacesStore/:nodeId/comments',
    delete: '/s/api/comment/node/workspace/SpacesStore/:nodeId'
  },
  alerts: {
    create: '/s/synapture/repository/alert',
    getalerts: '/s/fr/synapture/alert-for-user',
    changeAlertStatus: '/s/fr/synapture/alert-status?id=:alertId&',
    deleteAlert: '/s/fr/synapture/alert/alert-delete-all?id=:alertId&'
  },
  trashcan: {
    getDeletedItems: '/api/-default-/public/alfresco/versions/1/deleted-nodes',
    restore: DEFAULT_API + '/alfresco/versions/1/deleted-nodes/:nodeId/restore',
    deleteforever: DEFAULT_API + '/alfresco/versions/1/deleted-nodes/:nodeId',
    deleteall: '/s/api/archive/workspace/SpacesStore'
  },
  activities: {
    getUserActivities: '/s/api/activities/feed/user',
    getSiteActivities: '/s/api/activities/feed/site/:siteId',
    gettasks: '/s/api/task-instances',
    acceptTask: '/s/api/task/:taskId/formprocessor'
  },
  tasks: {
    getUserTasks: '/s/api/task-instances'
  },
  questions: {
    getQuestions:
      '/s/api/forum/discussions/posts/filtered?topics=mine&history=1&resultSize=10'
  },
  stats: {
    getAllnodes: '/s/slingshot/doclib/doclist/documents/node/alfresco/sites/home',
    getNodesSite: '/s/slingshot/doclib/doclist/documents/site/:siteId/documentLibrary?filter=all',
    getSites: '/api/-default-/public/alfresco/versions/1/sites?skipCount=0&maxItems=100'
  },
  anonymousEntity: {
    create: '/s/synapture/address',
    getAll: '/s/synapture/addresses',
    uploadLogo: '/s/synapture/address/uploadlogo',
    delete: '/s/synapture/address/workspace/SpacesStore/:nodeId',
    edit: '/s/synapture/address/workspace/SpacesStore/:nodeId',
  },
  images: {
    getimages: '/s/syn/images',
    getnotaireimages: '/s/syn/notaireimages'
  },
  versions: {
    getFiles: '/s/api/version',
    downloadVersion: '/s/api/node/content/versionStore/version2Store/:versionNodeId/:filename'
  },
  workspace: {
    archiver: '/s/api/type/cm%3Acontent/formprocessor',
    getdocumentlibrary: '/api/-default-/public/alfresco/versions/1/sites/:siteId/containers/documentLibrary'
  },
  metadatas: {
    apply: '/s/synapture/applyType'
  },
  signature: {
    getContent: DEFAULT_API + '/alfresco/versions/1/nodes/:nodeId/content',
    getParams: '/s/keensoft/sign/signature-params',
    saveSignature: '/s/keensoft/sign/save-sign'
  },
  cmm: {
    createAspect: '/api/-default-/private/alfresco/versions/1/cmm/:modelName/aspects',
    editAspect: '/api/-default-/private/alfresco/versions/1/cmm/:modelName/aspects/:aspectName',
    listAspects: '/api/-default-/private/alfresco/versions/1/cmm/:modelName/aspects',
    getAspect: '/api/-default-/private/alfresco/versions/1/cmm/:modelName/aspects/:aspectName',
    deleteAspect: '/api/-default-/private/alfresco/versions/1/cmm/:modelName/aspects/:aspectName',
    createProperty: '/api/-default-/private/alfresco/versions/1/cmm/:modelName/:entityClass/:entityName',
    editProperty: '/api/-default-/private/alfresco/versions/1/cmm/:modelName/:entityClass/:entityName',
    deleteProperty: '/api/-default-/private/alfresco/versions/1/cmm/:modelName/:entityClass/:entityName',
    getProperty: ''
  },
  getTasks: {
    tasks: '/api/-default-/public/workflow/versions/1/tasks',
    task: '/api/-default-/public/workflow/versions/1/tasks/:taskId',
    taskVariables: '/api/-default-/public/workflow/versions/1/tasks/:taskId/variables',
    currentTasks: '/api/-default-/public/workflow/versions/1/tasks',
    completedTasks: '/api/-default-/public/workflow/versions/1/tasks'
  }
};
